import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { message } from 'antd';
import Cookie from 'js-cookie';

import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

import App from 'page/App';
import store, { history } from './model/index';
import { AliveScope, autoFixContext } from 'react-activation';
import { fridayAgentInit } from '@cvte/react-fridayagent3';
import { v4 as uuidv4 } from 'uuid';
import { setAuthUserInfo } from 'data/storage';
import { getRuntimeEnv } from 'util/env';
import FRIDAY_APPID_MAP from 'constant/fridayAppId';
import { register } from 'nicehubs-plus/dist/web-component';

// 初始化CrossEnv
import { isSSO } from 'util/crossenv';

import './index.less';

// 注册自定义组件
register();

const runtimeEnv = getRuntimeEnv();

if (isSSO()) {
  // 将cookie写入storage
  setAuthUserInfo({
    userId: Cookie.get('x-auth-userId'),
    staffId: Cookie.get('x-staff-id'),
    companyId: Cookie.get('x-company-id'),
    orgCode: Cookie.get('x-org-code'),
    token: Cookie.get('x-auth-token'),
    mobile: Cookie.get('mobile')
  });
}

// message的全局配置
message.config({
  // duration: 2,
  maxCount: 1
});

// 埋点
const fridayAppid = FRIDAY_APPID_MAP[runtimeEnv] || '';
const fridayAgent = fridayAgentInit(fridayAppid, {
  debug: runtimeEnv === 'DEV'
});
fridayAgent.setEnv({
  endpoint_type: 'WEB_APP',
  app_version: 'V2.1',
  endpoint_id: uuidv4()
});

dayjs.locale('zh-cn');

autoFixContext(
  [require('react/jsx-runtime'), 'jsx', 'jsxs', 'jsxDEV'],
  // @ts-ignore
  [require('react/jsx-dev-runtime'), 'jsx', 'jsxs', 'jsxDEV']
);

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AliveScope>
          <App />
        </AliveScope>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );
};

render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
